<section class="parameter d-flex direction-column justify-space-between">
  <div class="parameter-header header row justify-flex-start">
    <span class="header-title" mat-dialog-title>Parâmetro</span>
  </div>
  <div class="parameter-body body row">
    <form class="row justify-space-between" [formGroup]="form">
      <app-c-input
        class="body-form"
        label="Nome do Parâmetro"
        formControlName="Name"
        [isParameter]="true"
      >
      </app-c-input>

      <app-c-input
        class="body-form"
        label="Valor"
        formControlName="Value"
        [isParameter]="true"
      >
      </app-c-input>
    </form>
  </div>
  <div class="parameter-footer footer row justify-space-between">
    <button type="button" class="footer-back ui-btn ui-btn--secondary" mat-dialog-close>Voltar</button>
    <button type="button" class="footer-save ui-btn ui-btn--primary" (click)="handlerParameter()">Salvar Parâmetros</button>
  </div>
</section>
